import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './LoginScreen.css';
import { useNavigate } from 'react-router-dom';
import '../i18n';
import { CircularProgress } from '@mui/material';
import { Alert } from '@mui/material';
import { IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import { createUser, authenticateUser } from '../Services/api';
import { useAuth } from '../Components/AuthContext';

const RegisterScreen = () => {
  const { login } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isInvalidResponse, setIsInvalidRespone] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      await createUser(email, password);
      const response = await authenticateUser(email, password);
      localStorage.setItem('token', response.token);
      setLoading(false);
      login(response.token);
      navigate('/main', { replace: true });
      setIsInvalidRespone(false);
    } catch (error) {
      console.error(t('authError'), error);
      setLoading(false);
      setIsInvalidRespone(true);
    }
  };

  return (
    <div className='background'>
      <div className="login-container">
        <div className='left-div-k10'>
          <div className="logo-container">
            <img src="./KeitoSalesLogoSinFondo.svg" alt="Logo Keito" className="logoKeito" />
            <div className="divider"></div>
          </div>
          <div className="welcome-container">
            <span className="title-welcome-part1">{t('title-register')} <a className="title-welcome-part2"> {t('eHealth')}</a></span>
          </div>
          <div className="title-intro">{t('intro-register')}</div>

          <form className="login-form" onSubmit={handleSubmit}>
            <label htmlFor="userNumber">{t('Email')}</label>
            <input type="text" id="userNumber" placeholder={t('email')} value={email} onChange={(e) => setEmail(e.target.value)} />

            <label htmlFor="password">{t('titlePassword')}</label>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                placeholder={t('passwordPlaceholder')}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{ flex: 1 }}
              />
              <IconButton
                onClick={() => setShowPassword(!showPassword)}
                edge="end"
                style={{
                  marginTop: '0px',
                  background: 'none',
                  boxShadow: 'none',
                  color: 'gray',
                  marginLeft: '0.1rem'
                }}
              >
                {showPassword ? <VisibilityOff style={{ fontSize: '2rem' }} /> : <Visibility style={{ fontSize: '2rem' }} />}
              </IconButton>
            </div>

            {isInvalidResponse && (
              <div style={{ display: 'flex', width: '100%', justifyContent: 'center', marginBottom: '1rem' }}>
                <Alert
                  severity="error"
                  style={{
                    fontSize: '1rem',
                    borderRadius: '1rem',
                    fontFamily: 'Poppins',
                    width: '100%'
                  }}
                  iconMapping={{
                    error: <ErrorOutline style={{ fontSize: '1.5rem', color: 'red', fontWeight: 'bold' }} />,
                  }}
                >
                  {t('authError')}
                </Alert>
              </div>
            )}

            <button className="submit">{loading ? <CircularProgress style={{ width: '20px', height: '20px', color: '#FFFFFF' }} /> : t('register')}</button>
          </form>
        </div>
        <div className='right-div-k10'>
          <img src="./res/K10IMG.png" alt="K10 Image" className="k10-image" />
          <div className="overlay"></div>
        </div>
      </div>
    </div>
  );
};

export default RegisterScreen;
